import { useTranslation } from 'react-i18next';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from '@/components/assist/ui/sheet';
import { useSupportDrawer } from '@/contexts/SupportDrawerContext';
import { TicketList } from './TicketList';
import { TicketCreateForm } from './TicketCreateForm';
import { TicketDetail } from './TicketDetail';

const TITLES: Record<string, string> = {
  list: 'support.drawer.titleList',
  create: 'support.drawer.titleCreate',
  detail: 'support.drawer.titleDetail',
};

export function SupportDrawer() {
  const { t } = useTranslation('assist');
  const { isOpen, view, closeDrawer } = useSupportDrawer();

  return (
    <Sheet open={isOpen} onOpenChange={(open) => !open && closeDrawer()}>
      <SheetContent
        side="right"
        className="!w-[var(--support-drawer-width)] !max-w-none min-w-[400px] flex flex-col"
        data-support-drawer="true"
      >
        <SheetHeader className="border-b border-border pb-4">
          <SheetTitle className="text-xl font-semibold">
            {t(TITLES[view] || TITLES.list, view === 'list' ? 'Support' : view === 'create' ? 'New Ticket' : 'Ticket')}
          </SheetTitle>
          <SheetDescription className="sr-only">
            {t('support.drawer.description', 'Manage support tickets')}
          </SheetDescription>
        </SheetHeader>
        <div className="flex-1 overflow-hidden pt-4 flex flex-col min-h-0">
          {view === 'list' && <TicketList />}
          {view === 'create' && <TicketCreateForm />}
          {view === 'detail' && <TicketDetail />}
        </div>
      </SheetContent>
    </Sheet>
  );
}
